import { i18n } from "@/i18n";

export const printFormats = () => [
    {
        ...parseTrans("proship"),
        size: "normal",
        printer: "proship",
        image: require("@/assets/printSamples/proship.png"),
    },

    {
        ...parseTrans("100x100"),
        size: "normal",
        printer: "x100",
        image: require("@/assets/printSamples/rts.png"),
    },

    {
        ...parseTrans("tsc"),
        size: "normal",
        printer: "tsc",
        image: require("@/assets/printSamples/tsc.png"),
    },
];

export const printLabels = (printSettings) => {
    const data = {
        paperSizes: {
            "กระดาษสติกเกอร์ 100x150 มม. (4 x 6 นิ้ว)": [
                {
                    ...parseTrans("proship"),
                    name: parseTrans("proship").name + "(v1)",
                    size: "normal",
                    printer: "proship",
                    image: require("@/assets/printSamples/proship.png"),
                },
            ],

            "กระดาษสติกเกอร์ 100x100 มม. (4 x 4 นิ้ว)": [{
                ...parseTrans("100x100"),
                size: "normal",
                printer: "x100",
                image: require("@/assets/printSamples/rts.png"),
            }],

            "กระดาษสติกเกอร์ 75x100 มม. (3 x 4 นิ้ว)": [
                {
                    ...parseTrans("tsc"),
                    size: "normal",
                    printer: "tsc",
                    image: require("@/assets/printSamples/tsc.png"),
                },

                {
                    ...parseTrans("tsc"),
                    name: parseTrans("tsc").name + "(แนวนอน)",
                    size: "normal",
                    printer: "100x75",
                    description: "",
                    image: require("@/assets/printSamples/100x75.png"),
                }
            ]
        },
        selectedPaperSize: "a4"
    }

    return data;
}

function parseTrans(trans) {
    let tUnits = i18n.t("printer_format." + trans).split("|");
    return ({
        name: tUnits[0] || "",
        // sizeToShow: tUnits[1] || "",
        description: tUnits[2] || "",
    })
}